var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "send-notification-expedient-container" },
    [
      _c(_setup.CustomDialogHeaderComponent, {
        attrs: { headerTitle: _setup.texts.title },
      }),
      _c("span", { staticClass: "required-fields-advice-base" }, [
        _vm._v(_vm._s(_setup.texts.requiredFields)),
      ]),
      _c(
        _setup.ValidationObserver,
        { ref: "nameInput", staticClass: "buttons-container" },
        [
          _c(_setup.LexonAutocompleteComponent, {
            attrs: {
              id: "sections",
              name: "sections",
              propItems: _setup.responsibles,
              label: _setup.texts.destLabel,
              multiple: "",
              chips: "",
              hasRelatedField: "",
              placeholder: _setup.texts.responsiblePlaceholder,
              itemName: "name",
              itemValue: "id",
              returnObject: "",
              addNew: false,
              validationRules: "required",
            },
            model: {
              value: _setup.selectedResponsibles,
              callback: function ($$v) {
                _setup.selectedResponsibles = $$v
              },
              expression: "selectedResponsibles",
            },
          }),
          _c(_setup.LexonTextFieldComponent, {
            attrs: {
              label: _setup.texts.subjectLabel,
              id: "name",
              name: "name",
              placeholder: _setup.texts.subjectPlaceholder,
              validationRules: "required|max:255",
            },
            on: { input: _setup.validateSubjectField },
            model: {
              value: _setup.subject,
              callback: function ($$v) {
                _setup.subject = $$v
              },
              expression: "subject",
            },
          }),
          _c(_setup.LexonTextAreaComponent, {
            attrs: {
              label: _setup.texts.messageLabel,
              id: _setup.texts.noteLabel,
              name: _setup.texts.noteLabel,
              placeholder: _setup.texts.notePlaceholder,
              maxlength: _setup.maxNumberOfCharactersInNotesField,
              validationRules: `required|max:${_setup.maxNumberOfCharactersInNotesField}`,
            },
            model: {
              value: _setup.noteText,
              callback: function ($$v) {
                _setup.noteText = $$v
              },
              expression: "noteText",
            },
          }),
        ],
        1
      ),
      _c(_setup.CustomDialogActionButtonsComponent, {
        attrs: {
          disabledButtons: _setup.disabledActionButton,
          mainAction: _setup.sendMail,
          primaryButtonText: _setup.texts.primaryButton,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }